import React from 'react';
// import logo from './logo.svg';
import './App.css';
import LayoutDefault from './layouts/layout_default';
import LayoutAuth from './layouts/layout_auth';
import Index from './pages/home';
import Services from './pages/services';
import About from './pages/about';
import Contact from './pages/contact';
import Login from './pages/login';
import Register from './pages/register';
import Terms from './pages/terms';
import VendorTerms from './pages/vendor-terms';
import FAQ from './pages/faq';
import Privacy from './pages/privacy';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './assets/css/base/variables.css';
import './assets/css/layout/main.css';
import LearningPage from './pages/learning';
import AquaDoc from './pages/aquadoc';
import StorePage from './pages/store';
import CartPage from './pages/store/cart';
import CheckoutPage from './pages/store/checkout';
import ProductDetail from './pages/store/product';
import Doctors from './pages/aquadoc/doctors';
import Doctor from './pages/aquadoc/doctor';
import AiChat from './pages/aquadoc/ai_chat';
import Cases from './pages/aquadoc/cases';
import Farms from './pages/aquadoc/farms';
// import Case from './pages/aquadoc/case';
import CasePage from './pages/aquadoc/case';
import Certificate from './pages/learning/certificate';
import DoctorRegister from './pages/doctor/register';
import DoctorLogin from './pages/doctor/login';
import DoctorDashboard from './pages/doctor';
import DoctorCases from './pages/doctor/cases';
import DoctorCase from './pages/doctor/case';
import DoctorProfile from './pages/doctor/profile';
import AHTRegister from './pages/aht/register';
import AHTLogin from './pages/aht/login';
import AHTDashboard from './pages/aht';
import AHTCases from './pages/aht/cases';
import AHTCase from './pages/aht/case';
import AHTProfile from './pages/aht/profile';
// import AdminSignin from './pages/admin/signin';
import AdminDashboard from './pages/admin';
import AdminFarms from './pages/admin/farms';
import AdminFarmers from './pages/admin/farmers';
import AdminDoctors from './pages/admin/doctors';
import VendorRegister from './pages/vendor/register';
import VendorLogin from './pages/vendor/login';
import VendorDashboard from './pages/vendor';
import VendorProducts from './pages/vendor/products';
import VendorOrders from './pages/vendor/orders';
import VendorNewProduct from './pages/vendor/product-new';
import VendorEditProduct from './pages/vendor/product-edit';
import AdminProducts from './pages/admin/products';
import AdminVendors from './pages/admin/vendors';
import AdminOrders from './pages/admin/orders';
import AdminCases from './pages/admin/cases';
import AdminCaseDetail from './pages/admin/case-detail';
import AdminDoctorDetail from './pages/admin/doctor-detail';
import AdminCourses from './pages/admin/courses';
import Orders from './pages/store/orders';
import OrderDetail from './pages/store/order-detail';
import LabRegister from './pages/lab/register';
import LabLogin from './pages/lab/login';
import LabDashboard from './pages/lab';
import LabCases from './pages/lab/cases';
import LabCase from './pages/lab/case';
import AdminLab from './pages/admin/labs';
import LogisticsRegister from './pages/logistics/register';
import LogisticsDashboard from './pages/logistics';
import LogisticsShipments from './pages/logistics/shipments';
import LogisticsProfile from './pages/logistics/profile';
import LogisticsRates from './pages/logistics/rates';
import { SpeedInsights } from "@vercel/speed-insights/react"
import LandingPage from './pages/landing/LandingPage';
import MailVerification from './pages/auth/verify-email';
import VerificationSuccess from './pages/auth/verify-sucess';
import ForgotPassword from './pages/auth/forgot_password';
import ResetPassword from './pages/auth/reset-password';
import ResetSuccess from './pages/auth/reset-success';
import ProtectedRoute from './components/auth/ProtectedRoute';
import ErrorBoundary from './components/error/ErrorBoundary';
import RedirectIfAuthenticated from './components/auth/RedirectIfAuthenticated';
import CoursePage from './pages/learning/course';
import Dashboard from './pages/aquadoc/dashboard';
import RegisterPending from './pages/doctor/registration-pending';
import { CartProvider } from './context/CartContext';
import LayoutAdmin from './layouts/layout_admin';
import OnboardingTour from './components/common/OnboardingTour';
import HelpButton from './components/common/HelpButton';
import { useEffect, useState, useMemo } from 'react';
import ScrollToTop from './components/common/ScrollToTop';
import UserProfile from './pages/profile';
import MessagesPage from './pages/messages';
import { useAuth } from './context/AuthContext';
import AdminSignin from './pages/admin/signin';

function App() {

    const { user } = useAuth();
    const [showOnboarding, setShowOnboarding] = useState(false);
    
    // Determine user type for onboarding
    const userType = useMemo(() => {
        if (!user) return 'farmer'; // Default for non-authenticated users
        if (user.is_doctor) return 'vet';
        if (user.is_aht) return 'aht';
        if (user.is_laboratory) return 'lab';
        if (user.is_vendor) return 'vendor';
        if (user.is_admin) return 'admin';
        return 'farmer'; // Default for regular users
    }, [user]);
    
    useEffect(() => {
        // Show onboarding tour when not completed for this user type
        const onboardingKey = `onboardingCompleted_${userType}`;
        const onboardingCompleted = localStorage.getItem(onboardingKey);
        if (!onboardingCompleted) {
            setShowOnboarding(true);
        }
    }, [userType]);
    
    const handleOnboardingComplete = () => {
        const onboardingKey = `onboardingCompleted_${userType}`;
        localStorage.setItem(onboardingKey, 'true');
        localStorage.setItem(`onboardingCompletedAt_${userType}`, new Date().toISOString());
        setShowOnboarding(false);
    };

  return (
      <ErrorBoundary>
        <CartProvider>
        <BrowserRouter>
        <ScrollToTop />
        <SpeedInsights/>
            {showOnboarding && (
                <OnboardingTour
                    onComplete={handleOnboardingComplete}
                    userType={userType}
                />
            )}
            <HelpButton 
                onClick={() => setShowOnboarding(true)} 
                position="bottom-right"
            />
          <Routes>
            {/* <Route path="/" element={<LandingPage />} /> */}
            <Route path="/" element={<LayoutDefault />}>
              <Route index element={<Index />} />
              <Route path="/home" element={<LandingPage />} />
              <Route path="/services" element={<Services />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/vendor-terms" element={<VendorTerms />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/about" element={<About />} />
              <Route path="/learning">
                  <Route index element={<LearningPage />} />
                  <Route 
                      path="course/:courseId" 
                      element={
                          // <ProtectedRoute>
                              <CoursePage />
                          // </ProtectedRoute>
                      } 
                  />
              </Route>
              <Route path="/store" element={<StorePage />} />
              <Route path="/marketplace/product/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={
                <ProtectedRoute>
                  <CheckoutPage />
                </ProtectedRoute>
              } />
              <Route path="/store/orders" element={
                <ProtectedRoute>
                  <Orders />
                </ProtectedRoute>
              } />
              <Route path="/store/orders/:orderId" element={
                <ProtectedRoute>
                  <OrderDetail />
                </ProtectedRoute>
              } />
              <Route path="/contact" element={<Contact />} />
              <Route path="/doctors" element={<Doctors />} />
              <Route path="/chat" element={<AiChat />} />

              <Route path="/certificate" element={
                <ProtectedRoute>
                  <Certificate />
                </ProtectedRoute>
              } />
              <Route path="/aqua-doc" element={<AquaDoc />} />
              <Route path="/doctor/:id" element={<Doctor />} />
              <Route path="/dashboard">
              <Route index element={
                <ProtectedRoute> 
                  <Dashboard />
                </ProtectedRoute>
                } />
              </Route>
              <Route path="/cases">
              <Route index element={
                <ProtectedRoute> 
                  <Cases />
                </ProtectedRoute>
                } />
                <Route path=":caseId" element={
                  <ProtectedRoute>
                    <CasePage />
                  </ProtectedRoute>
                    } />
              </Route> 
              <Route path="/farms" element={
                <ProtectedRoute>
                  <Farms />
                  </ProtectedRoute>
                } />
              <Route path="/orders" element={<ProtectedRoute>
                <Orders />
                </ProtectedRoute>
                } />
            </Route>

            <Route path='/logistics/register' element={<LayoutAuth  />}>
              <Route index element={<LogisticsRegister />} />
            </Route>

            <Route path='/logistics' element={<LayoutDefault />}>
              <Route index element={
                <ProtectedRoute requiredRole="logistics">
                  <LogisticsDashboard/>
                </ProtectedRoute>} />
              <Route path='shipments' element={
                <ProtectedRoute requiredRole="logistics">
                  <LogisticsShipments />
                </ProtectedRoute>} />
              <Route path='shipments/:id' element={
                <ProtectedRoute requiredRole="logistics">
                  <LogisticsShipments />
                </ProtectedRoute>} />
              <Route path='rates' element={
                <ProtectedRoute requiredRole="logistics">
                  <LogisticsRates />
                </ProtectedRoute>} />
              <Route path='profile' element={
                <ProtectedRoute requiredRole="logistics">
                  <LogisticsProfile />
                </ProtectedRoute>} />
            </Route>

            <Route path="/login" element={<LayoutAuth />}>
              <Route index element={
                <RedirectIfAuthenticated>
                  <Login />
                </RedirectIfAuthenticated>
                } />
            </Route>
            <Route path="/verify-email" element={<LayoutAuth />}>
              <Route index element={<MailVerification />} />
            </Route>
            <Route path="/verify-success" element={<LayoutAuth />}>
              <Route index element={<VerificationSuccess />} />
            </Route>
            <Route path="/forgot-password" element={<LayoutAuth />}>
              <Route index element={<ForgotPassword />} />
            </Route>
            <Route path="/reset-password" element={<LayoutAuth />}>
              <Route index element={<ResetPassword />} />
            </Route>
            <Route path="/reset-success" element={<LayoutAuth />}>
              <Route index element={<ResetSuccess />} />
            </Route>
            <Route path="/register" element={<LayoutAuth />}>
              <Route index element={
                <RedirectIfAuthenticated>
                  <Register />
                </RedirectIfAuthenticated>
                } />
            </Route>
            <Route path='/profile' element={<LayoutDefault />}>
              <Route index element={
                <ProtectedRoute>
                  <UserProfile />
                </ProtectedRoute>
              } />
            </Route>

            <Route path='/messages' element={<LayoutDefault />}>
              <Route index element={
                <ProtectedRoute>
                  <MessagesPage />
                </ProtectedRoute>
              } />
            </Route>

            <Route path='/vet' element={<LayoutDefault />}>
              <Route index element={
                <ProtectedRoute requiredRole="doctor">
                  <DoctorDashboard/>
                  </ProtectedRoute>} />
              <Route path='cases' element={
                <ProtectedRoute requiredRole="doctor">
                <DoctorCases />
                </ProtectedRoute>} />
              <Route path='cases/:id' element={
                <ProtectedRoute requiredRole="doctor">
                  <DoctorCase />
                  </ProtectedRoute>} />
              <Route path='profile' element={
                <ProtectedRoute requiredRole="doctor">
                  <DoctorProfile/>
                  </ProtectedRoute>} />
            </Route>
            <Route path='/vet/register' element={<LayoutAuth  />}>
              <Route index element={<DoctorRegister />} />
            </Route>
            <Route path="/vet/register-pending" element={<LayoutAuth  />}>
              <Route index element={<RegisterPending />} />
            </Route>
            <Route path='/vet/login' element={<LayoutAuth  />}>
              <Route index element={<DoctorLogin />} />
            </Route>

            {/* Animal Health Technologist Routes */}
            <Route path='/aht' element={<LayoutDefault />}>
              <Route index element={
                <ProtectedRoute requiredRole="aht">
                  <AHTDashboard/>
                </ProtectedRoute>} />
              <Route path='cases' element={
                <ProtectedRoute requiredRole="aht">
                  <AHTCases />
                </ProtectedRoute>} />
              <Route path='case/:caseId' element={
                <ProtectedRoute requiredRole="aht">
                  <AHTCase />
                </ProtectedRoute>} />
              <Route path='profile' element={
                <ProtectedRoute requiredRole="aht">
                  <AHTProfile/>
                </ProtectedRoute>} />
            </Route>
            <Route path='/aht/register' element={<LayoutAuth  />}>
              <Route index element={<AHTRegister />} />
            </Route>
            <Route path='/aht/login' element={<LayoutAuth  />}>
              <Route index element={<AHTLogin />} />
            </Route>


            <Route path='/vendor/register' element={<LayoutAuth  />}>
              <Route index element={<VendorRegister />} />
            </Route>
            <Route path='/vendor/login' element={<LayoutAuth  />}>
              <Route index element={<VendorLogin />} />
            </Route>
            <Route path='/vendor' element={<LayoutDefault />}>
              <Route index element={
                <ProtectedRoute requiredRole="vendor">
                  <VendorDashboard/>
                  </ProtectedRoute>} />
              <Route path='products' element={
                <ProtectedRoute requiredRole="vendor">
                  <VendorProducts />
                  </ProtectedRoute>} />
              <Route path='products/new' element={
                <ProtectedRoute requiredRole="vendor">
                  <VendorNewProduct />
                  </ProtectedRoute>} />
              <Route path='products/:id/edit' element={
                <ProtectedRoute requiredRole="vendor">
                  <VendorEditProduct />
                  </ProtectedRoute>} />
              <Route path='orders' element={
                <ProtectedRoute requiredRole="vendor">
                  <VendorOrders/>
                  </ProtectedRoute>} />
              <Route path='profile' element={
                <ProtectedRoute requiredRole="vendor">
                  <DoctorProfile/>
                  </ProtectedRoute>} />
            </Route>

            <Route path='/lab/register' element={<LayoutAuth  />}>
              <Route index element={<LabRegister />} />
            </Route>
            <Route path='/lab/login' element={<LayoutAuth  />}>
              <Route index element={<LabLogin/>} />
            </Route>
            <Route path='/lab' element={<LayoutDefault />}>
              <Route index element={
                <ProtectedRoute requiredRole="lab">
                  <LabDashboard/>
                  </ProtectedRoute>} />
              <Route path='cases' element={
                <ProtectedRoute requiredRole="lab">
                  <LabCases />
                  </ProtectedRoute>} />
              <Route path='cases/:id' element={
                <ProtectedRoute requiredRole="lab">
                  <LabCase />
                  </ProtectedRoute>} />
            </Route>


            <Route path='/admin/login' element={<LayoutAuth  />}>
              <Route index element={
                <RedirectIfAuthenticated>
                  <AdminSignin />
                </RedirectIfAuthenticated>
              } />
            </Route>
            <Route path='/admin' element={<LayoutAdmin />}>
              <Route index element={
                <ProtectedRoute requiredRole="admin">
                    <AdminDashboard />
                </ProtectedRoute>
              } />
              <Route path='cases' element={
                <ProtectedRoute requiredRole="admin">
                  <AdminCases />
                  </ProtectedRoute>
                } />
              <Route path='cases/:id' element={
                <ProtectedRoute requiredRole="admin">
                  <AdminCaseDetail />
                </ProtectedRoute>
              } />
              <Route path='courses' element={
                <ProtectedRoute requiredRole="admin">
                  <AdminCourses />
                  </ProtectedRoute>} />
              <Route path='farms' element={
                <ProtectedRoute requiredRole="admin">
                  <AdminFarms/>
                  </ProtectedRoute>} />
              <Route path='farmers' element={
                <ProtectedRoute requiredRole="admin">
                  <AdminFarmers/>
                  </ProtectedRoute>} />
              <Route path='doctors' element={
                <ProtectedRoute requiredRole="admin">
                  <AdminDoctors/>
                  </ProtectedRoute>} />
              <Route path='doctors/:id' element={
                <ProtectedRoute requiredRole="admin">
                  <AdminDoctorDetail/>
                </ProtectedRoute>} />
              <Route path='vendors' element={
                <ProtectedRoute requiredRole="admin">
                  <AdminVendors/>
                  </ProtectedRoute>} />
              <Route path='products' element={
                <ProtectedRoute requiredRole="admin">
                  <AdminProducts/>
                  </ProtectedRoute>} />
              <Route path='orders' element={
                <ProtectedRoute requiredRole="admin">
                  <AdminOrders/>
                  </ProtectedRoute>} />
              <Route path='labs' element={
                <ProtectedRoute requiredRole="admin">
                  <AdminLab/>
                  </ProtectedRoute>} />
              <Route path='profile' element={
                <ProtectedRoute requiredRole="admin">
                  <DoctorProfile/>
                  </ProtectedRoute>} />
            </Route>

          </Routes>
        </BrowserRouter>
        </CartProvider>
      </ErrorBoundary>
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.js</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>
  );
}

export default App;
